import React from 'react'
import styled from 'styled-components'

// A PureComponent
const ResponsiveFont = React.memo<{
    ratio: number
    children?: React.ReactNode
}>(({ ratio = 35, children }) => {
    const fontSize = calculateFontSize(ratio)

    return <FontContainer $size={fontSize}>{children}</FontContainer>
})

export default ResponsiveFont

export const calculateFontSize = (ratio: number) => {
    const MIN_FONT_SIZE = 20
    const windowWidth = window.innerWidth
    const windowHeight = window.innerHeight
    const isPortrait = windowWidth < windowHeight

    const fontCalculated = isPortrait ? windowHeight / ratio : windowWidth / ratio
    const fontSize = fontCalculated < MIN_FONT_SIZE ? MIN_FONT_SIZE : fontCalculated

    return Math.ceil(fontSize)
}

interface FontContainerProps {
    $size: number
}

const FontContainer = styled.span<FontContainerProps>`
    font-size: ${(props: FontContainerProps) => props.$size}px;
`
